exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article[data-v-63f0a6e7]{-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.article-move[data-v-63f0a6e7]{-webkit-transition:all .6s ease-in-out 50ms;transition:all .6s ease-in-out 50ms}.article-enter-active[data-v-63f0a6e7]{-webkit-transition:all .4s ease-out;transition:all .4s ease-out}.article-leave-active[data-v-63f0a6e7]{-webkit-transition:all .2s ease-in;transition:all .2s ease-in;position:absolute;z-index:0}.article-enter[data-v-63f0a6e7],.article-leave-to[data-v-63f0a6e7]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63f0a6e7","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/front/search/simple-search.vue
// module id = jHog
// module chunks = 0